import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatDuration } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  taxi_in_eligible_time_seconds: 422,
  single_engine_taxi_in_duration_seconds: 162,
  constant_seti_min_required_single_engine_seconds: 120,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);

export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  const eligibleSeconds = Number(metadata["taxi_in_eligible_time_seconds"]);
  const setiSeconds = Number(
    metadata["single_engine_taxi_in_duration_seconds"],
  );
  const thresholdSeconds = Number(
    metadata["constant_seti_min_required_single_engine_seconds"],
  );

  if (isNaN(eligibleSeconds) || isNaN(setiSeconds) || isNaN(thresholdSeconds)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const isSuccess = setiSeconds >= thresholdSeconds;
  const domainMax = Math.ceil(Math.max(eligibleSeconds, setiSeconds) * 1.15);
  const domain = [0, domainMax];
  const barColour = isSuccess ? bvrColour.codes["500"] : bvrColour.codes["200"];
  const formatter = (seconds) => formatDuration(seconds).asString;

  const data = [
    {
      name: "Taxi time minus cooldown",
      mobileName: "Eligible taxi",
      beforeThreshold: Math.min(eligibleSeconds, thresholdSeconds),
      afterThreshold: Math.max(0, eligibleSeconds - thresholdSeconds),
      underThresholdColour: barColour,
      overThresholdColour: barColour,
    },
    {
      name: "Single engine taxi duration",
      mobileName: "Single engine",
      beforeThreshold: Math.min(setiSeconds, thresholdSeconds),
      afterThreshold: Math.max(0, setiSeconds - thresholdSeconds),
      underThresholdColour: barColour,
      overThresholdColour: barColour,
    },
  ];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={thresholdSeconds}
      thresholdLabel={`Signol threshold\n(${formatter(thresholdSeconds)})`}
      domain={domain}
      refLineColour={bvrColour.codes["900"]}
      success={isSuccess}
      axisLabel="Time"
      unitOfMeasure="s"
      hideNum={true}
      hideYLine={true}
      barLabelFormatter={formatter}
      barLabelFormatterMobile={formatter}
      isExample={isExample}
    />
  );
}
